<template>
  <div :class="$options.name">
    <v-card>
      <data-table
        ref="data-table"
        reference="data-table"
        :list="data.list"
        :is-loading="isLoading"
        :headers="headers"
        :options.sync="options"
        :pagination="data.pagination"
        @change-page="onChangePage"
      >
        <template #toolbar>
          <create-button
            :permissions="['dangerous-criteria-create']"
            dialog="dangerous-criteria-dialog"
          />
          <div class="flex-grow-1" />
          <search-filter
            ref="search-filter"
            v-model="data"
            original-module="dangerousCriteria"
            name-filter
            :data-table-options="options"
            :is-loading.sync="isLoading"
            :page="page"
          />
        </template>

        <template #item.actions="{ item }">
          <div class="data-table-actions">
            <edit-button
              :permissions="['dangerous-criteria-edit']"
              dialog="dangerous-criteria-dialog"
              :disabled="isLoading"
              :item="item"
            />
            <delete-button
              :permissions="['dangerous-criteria-delete']"
              :disabled="isLoading"
              :item-id="item.id"
              @onRemove="onRemove"
            />
          </div>
        </template>
      </data-table>
    </v-card>
    <dangerous-criteria-dialog @submit="submit" />
    <remove-confirmation
      name="remove-confirmation"
      title="Вы действительно желаете удалить элемент?"
      @confirmed="onRemove"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CreateButton from '@/components/common/create-button';
import DataTable from '@/components/common/data-table';
import SearchFilter from '@/components/common/search-filter';
import EditButton from '@/components/common/edit-button';
import DeleteButton from '@/components/common/delete-button';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';
import DangerousCriteriaDialog from './components/DangerousCriteriaDialog.vue';

export default {
  name: 'dangerous-criteria-list',
  asyncData({ store }) {
    const actions = [
      store.dispatch('dangerousInformers/getFullList'),
    ];

    return Promise.all(actions);
  },
  components: {
    DeleteButton,
    EditButton,
    SearchFilter,
    DataTable,
    CreateButton,
    DangerousCriteriaDialog,
    RemoveConfirmation,
  },
  data: () => ({
    data: { list: [], pagination: {}, isSearch: false },
    page: 1,
    isLoading: false,
    headers: [
      { value: 'name', text: 'Название критерия', sortable: false },
      { value: 'actions', sortable: false, width: '20%' },
    ],
    options: {},
  }),
  methods: {
    ...mapActions('dangerousCriteria', ['remove', 'create', 'update']),

    submit({ form, isEdit }) {
      this.viaLoading(async () => {
        if (!isEdit) {
          await this.create(form);
        } else {
          await this.update(form);
        }
        await this.updateData(this.page);
      });
    },

    async onChangePage(page) {
      this.page = page;
    },

    onRemove(id) {
      this.viaLoading(async () => {
        await this.remove(id);
        await this.updateData();
      });
    },

    async viaLoading(cb) {
      this.isLoading = true;
      await cb();
      this.isLoading = false;
    },

    async updateData(page = null) {
      await this.$refs['search-filter'].getTableList(page);
    },
  },
};
</script>

<style scoped>

</style>
